import React, { useState }  from 'react';
import { ArrowRight, CheckCheck } from 'lucide-react';
import type { Event } from '@/types/event';
import EventImage from './EventImage';
import EventStats from './EventStats';

interface EventCardProps {
  event: Event;
  quota?: any;
  onViewDetails: (event: Event) => void;
  onReserve: (event: Event) => void;
  onClick: () => void;
  onQuickRegister: (eventId: string | number) => void;
  onQuickUnregister: (eventId: string | number) => void;
  isRegistered: boolean;
  isRegistering: boolean;
}

const EventCard: React.FC<EventCardProps> = ({
  event,
  quota = {},
  onClick,
  onReserve,
  onViewDetails,
  onQuickRegister,
  onQuickUnregister,
  isRegistered,
  isRegistering
}) => {
  // const [imageError, setImageError] = useState(false);

  const getQuickActionText = () => {
    if (isRegistering) return 'Processing...';
    return isRegistered ? 'Reserved' : 'Reserve Now';
  };

  // const isFeatured = event.is_featured || false;
  const tag = event.taggings?.[0]?.name || null;
  const category = tag || event.category as string || null;
  const type = tag || category || event.type || null;

  return (
    <div className="flex flex-col md:flex-row bg-white/5 border rounded-xl md:rounded-2xl shadow-lg overflow-hidden hover:shadow-orange-700/30 transition-all duration-300 ease-in-out hover:scale-[1.02] md:hover:scale-105">
      <EventImage event={event} />
      
      <div className="p-4 sm:p-5 md:p-6 flex flex-col w-full md:w-2/3 justify-between">
        {type && <div className="flex text-left justify-between mb-2 sm:mb-3">
          <span className="bg-gradient-to-r from-orange-500 to-orange-600 text-white text-xs uppercase font-light px-2 sm:px-3 py-1 rounded-sm tracking-widest whitespace-nowrap">
            {type}
          </span>
        </div>}
        
        <div className="mb-3 sm:mb-4">
          <h3 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-semibold text-left mb-2 sm:mb-3 line-clamp-2">
            {event.title}
          </h3>
        </div>
        
        <div className="mb-4 sm:mb-5 md:mb-6">
          <EventStats event={event} />
        </div>
        
        <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
          {!event.is_reserved && (
            <button
              onClick={() => onReserve(event)}
              disabled={isRegistering || isRegistered}
              className={`bg-gradient-to-r ${isRegistered ? 'from-green-500 to-green-600 hover:from-green-600 hover:to-green-500' : 'from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-500'} text-white px-3 sm:px-4 py-1.5 sm:py-1 rounded-full font-normal transition-all flex items-center justify-center text-sm sm:text-base`}
            >
              {getQuickActionText()}
              {isRegistered ? <CheckCheck size={16} className="sm:w-4 sm:h-4 ml-1 sm:ml-2 inline" /> : <ArrowRight size={16} className="sm:w-4 sm:h-4 ml-1 sm:ml-2 inline" />}
            </button>
          )}
          <button 
            onClick={() => onViewDetails(event)} 
            className="bg-white hover:bg-white/75 text-black px-3 sm:px-4 py-1.5 sm:py-1 rounded-full font-normal transition-all text-sm sm:text-base"
          >
            View Details
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventCard;